import {CALLING, CAMERA} from "../apiConstant";
import BaseApi from "../baseApi";

class CallingApi extends BaseApi {
  sendRequest(param) {
    return this.post(`api${CALLING}request`, param);
  }

  /* new */

  /* signaling */
  createRoom(param) {
    return this.post(`api${CALLING}create-room`, param);
  }

  addMember(param){
    return this.post(`api${CALLING}add-member`, param);
  }

  getRoom(param) {
    return this.post(`api${CALLING}get-room`, param);
  }

  getWaitingCall() {
    return this.post(`api${CALLING}get-waiting-call`);
  }

  ring(param) {
    return this.post(`api${CALLING}ring`, param);
  }

  produce(param) {
    return this.post(`api${CALLING}produce`, param);
  }

  shareScreen(param) {
    return this.post(`api${CALLING}/share-screen`, param);
  }

  reject(param) {
    return this.post(`api${CALLING}close`, param);
  }

  /* sfu */
  // getRtpCapabilities() {
  //   return this.post(`${CALLING}/get-rtpCapabilities`);
  // }
  //
  // createTransport(param) {
  //   return this.post(`${CALLING}/create-transport`, param);
  // }
  //
  // connectTransport(param) {
  //   // param: { connectionId, dtlsParameters, direction: 'send' | 'recv' }
  //   return this.post(`${CALLING}/connect-transport`, param);
  // }
  //
  // produce(param) {
  //   return this.post(`${CALLING}/produce`, param);
  // }
  //
  // createConsumer(param) {
  //   // param: { cameraId, connectionId, rtpCapabilities }
  //   return this.post(`${CALLING}/create-consumer`, param);
  // }
  //
  // close(param) {
  //   return this.post(`${WEBCAM}/close-webcam`, param);
  // }
}

export default CallingApi;
